import { PhoneNumberUtil } from 'google-libphonenumber';
export const getSamplePhoneNumber = (countryCode, phoneNumberType) => {
  const phoneUtils = PhoneNumberUtil.getInstance();
  const phoneNumber = phoneUtils.getExampleNumberForType(countryCode, phoneNumberType);
  if (phoneNumber) {
    return phoneUtils.format(phoneNumber);
  }
  return null;
};
export const getPrefixForCountry = countryCode => {
  const phoneUtils = PhoneNumberUtil.getInstance();
  return phoneUtils.getCountryCodeForRegion(countryCode);
};
export const isValidatePhoneNumber = (phoneNumber, countryCode) => {
  const phoneUtils = PhoneNumberUtil.getInstance();
  return phoneUtils.isValidNumber(phoneUtils.parse(phoneNumber, countryCode));
};